import {
  configureStore,
  combineReducers,
} from "@reduxjs/toolkit";

import {
  setupListeners,
} from "@reduxjs/toolkit/query";

import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";

import {
  TypedUseSelectorHook,
  useDispatch,
  useSelector,
} from "react-redux";

import Cookies from "cookies-js";

import CookieStorage from "./cookieStore";

import { Api } from "_services/api";

import example from "./example";

import auth from "./auth";

import globalComponent from "./global-components";

import driverTripCalculator from "./driver-trip-calculator";

import fleetReducer from "modules/master-data/fleet/list/store/fleetSlice";

const reducers =
  combineReducers({
    example,

    auth,

    globalComponent,

    driverTripCalculator,

    fleet:
      fleetReducer,

    [Api.reducerPath]:
      Api.reducer,
  });

const persistConfig = {
  key:
    "examplereduxkeystore",

  storage:
    new CookieStorage(
      Cookies,
      {},
    ),

  whitelist: [
    "globalComponent",
    "auth",
    "example",
  ],
};

const persistedReducer =
  persistReducer(
    persistConfig,
    reducers,
  );

const store =
  configureStore({
    reducer:
      persistedReducer,

    middleware:
      (
        getDefaultMiddleware,
      ) =>
        getDefaultMiddleware({
          serializableCheck:
          {
            ignoredActions: [
              FLUSH,
              REHYDRATE,
              PAUSE,
              PERSIST,
              PURGE,
              REGISTER,
            ],
          },
        }).concat(
          Api.middleware,
        ),
  });

const persistor =
  persistStore(store);

setupListeners(
  store.dispatch,
);

export type RootState =
  ReturnType<
    typeof reducers
  >;

export const useAppDispatch =
  () =>
    useDispatch<any>();

export const useAppSelector:
  TypedUseSelectorHook<RootState> =
  useSelector;

export {
  store,
  persistor,
};